import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=ce25a504&scoped=true"
import script from "./Factory.vue?vue&type=script&lang=ts"
export * from "./Factory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce25a504",
  null
  
)

export default component.exports